import {
  FETCH_INVENTORY,
  FETCH_INVENTORY_SUCCESS,
  FETCH_INVENTORY_FAILED,
  EDIT_INVENTORY,
} from '../store/types';

const INITIAL_STATE = {
  byPartnerId: {},
  loading: false,
  error: { flag: false, msg: null },
};

export const inventoryreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_INVENTORY:
      return { ...state, loading: true };
    case FETCH_INVENTORY_SUCCESS: {
      const { partnerId, items } = action.payload || {};
      return {
        ...state,
        loading: false,
        byPartnerId: {
          ...state.byPartnerId,
          [partnerId]: items,
        },
        error: { flag: false, msg: null },
      };
    }
    case FETCH_INVENTORY_FAILED: {
      const { partnerId, msg } = action.payload || {};
      return {
        ...state,
        loading: false,
        byPartnerId: {
          ...state.byPartnerId,
          [partnerId]: [],
        },
        error: { flag: true, msg },
      };
    }
    case EDIT_INVENTORY:
      return state;
    default:
      return state;
  }
};
